module.exports = __webpack_public_path__ + "img/BlinX Logo.19090334.png";